import { styled, Switch } from "@monolith-forensics/monolith-ui";
import { EvidenceDetailsDisplay, useEvidenceContext } from "@/Features";
import { useLayoutEffect, useRef } from "react";

const StyledHeaderTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) =>
    theme.name === "DARK"
      ? theme.palette.text.secondary
      : theme.palette.text.primary};
`;

const StyledSidePanel = styled.div`
  display: none;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-y: auto;
  width: 500px;
  max-width: 500px;
  min-width: 500px;
  border-left: 1px solid ${({ theme }) => theme.palette.divider};
  padding-left: 20px;

  transition: transform 0.1s ease-out, margin-left 0.1s ease-out;
`;

const StyledDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
  overflow-y: auto;
  height: 0px;
`;

export const EvidenceDetailsSidePanel: React.FC<{
  show: boolean;
}> = ({ show }) => {
  const evidenceContext = useEvidenceContext();

  const panelRef = useRef<HTMLDivElement>(null);
  if (!evidenceContext) {
    throw new Error("Evidence context not found");
  }
  const { data: evidenceInfo } = evidenceContext;

  useLayoutEffect(() => {
    if (!show) {
      panelRef.current!.style.transform = "translateX(550px)";
      panelRef.current!.style.marginLeft = "-500px";
      setTimeout(() => {
        panelRef.current!.style.display = "none";
      }, 100);
    } else {
      panelRef.current!.style.display = "flex";
      setTimeout(() => {
        panelRef.current!.style.transform = "translateX(0px)";
        panelRef.current!.style.marginLeft = "10px";
      }, 0);
    }
  }, [show]);

  return (
    <StyledSidePanel className={show ? "show" : "hide"} ref={panelRef}>
      <StyledHeaderTitle style={{ marginBottom: 10 }}>
        Evidence Summary for {evidenceInfo?.model_name || "Unnamed Item"} (
        {evidenceInfo?.evidence_number})
      </StyledHeaderTitle>
      <Switch
        value={evidenceContext.hideEmptyFields}
        onChange={evidenceContext.setHideEmptyFields}
        label="Hide Empty Fields"
        description="Hide empty fields from the evidence summary. This setting persists per host."
        size="xs"
      />
      <StyledDetailsContainer style={{ marginTop: 10 }}>
        <EvidenceDetailsDisplay
          orientation="vertical"
          style={{ marginTop: 10 }}
          dataFieldIgnoreList={["description"]}
          hideEmptyFields={evidenceContext.hideEmptyFields}
        />
      </StyledDetailsContainer>
    </StyledSidePanel>
  );
};
